import auth from "@/middleware/auth";

export default [
    {
        path: "resumo-acordo",
        name: "resumoAcordoTribanco",
        meta: { middleware: [auth] },
        component: () => import("./ResumoAcordoTribanco")
    }
];
